import * as React from "react";
import { Image as ImageIcon } from "lucide-react";

import { cn } from "@/lib/utils";

// NOTE: This component avoids broken external images (common in prototypes).
// If the network image fails, it renders a token-based placeholder.
export const SmartImage = ({
  src,
  alt,
  className,
  imgClassName,
  loading = "lazy",
  width,
  height,
  aspectRatio = "auto", // "video" | "square" | "portrait" | "auto"
}) => {
  const [broken, setBroken] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  // Define aspect ratio classes for CLS prevention
  const aspectClasses = {
    video: "aspect-video",
    square: "aspect-square",
    portrait: "aspect-[3/4]",
    auto: "",
  };

  if (broken || !src) {
    return (
      <div
        aria-label={alt}
        className={cn(
          "relative grid h-full w-full place-items-center",
          "bg-gradient-hero",
          "text-foreground/80",
          aspectClasses[aspectRatio],
          className
        )}
      >
        <div className="pointer-events-none absolute inset-0 opacity-[0.06] mix-blend-overlay [background-image:var(--noise)]" />
        <div className="grid place-items-center gap-2">
          <div className="grid size-12 place-items-center rounded-2xl border border-border/60 bg-background/25">
            <ImageIcon className="size-5" />
          </div>
          <div className="text-xs text-muted-foreground">Artwork unavailable</div>
        </div>
      </div>
    );
  }

  return (
    <div className={cn("relative h-full w-full", aspectClasses[aspectRatio], !loaded && "bg-muted/30 animate-pulse", className)}>
      <img
        src={src}
        alt={alt}
        loading={loading}
        width={width}
        height={height}
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setBroken(true)}
        className={cn(
          "h-full w-full",
          loaded ? "opacity-100" : "opacity-0",
          imgClassName
        )}
      />
    </div>
  );
};
